/**
 * @generated SignedSource<<3065fb69b17d55cf4efce348c6d42036>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespDesignTiles_itemSearch$data = {
  readonly displayUriRef: string | null;
  readonly creatorDesignTiles: ReadonlyArray<{
    readonly displayName: string | null;
    readonly imageUrl: string | null;
    readonly linkData: {
      readonly " $fragmentSpreads": FragmentRefs<"SeoLink_linkData">;
    };
  } | null> | null;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespDesignsDescriptionTile_itemSearch">;
  readonly " $fragmentType": "SbRespDesignTiles_itemSearch";
};
export type SbRespDesignTiles_itemSearch$key = {
  readonly " $data"?: SbRespDesignTiles_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespDesignTiles_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespDesignTiles_itemSearch",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespDesignsDescriptionTile_itemSearch"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayUriRef",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CreatorDesignTiles",
      "kind": "LinkedField",
      "name": "creatorDesignTiles",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LinkData",
          "kind": "LinkedField",
          "name": "linkData",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "SeoLink_linkData"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "c735b8935d8e17bfd8540f0c10b8f845";

export default node;
